import GuarantorsScreen from './GuarantorsScreen';

export default GuarantorsScreen;
